import S from 's-js';

import { CoordinationCardSelf } from 'data/models/CoordinationCardSelf';

import { EventLog, EventLogParams } from 'portcall/eventlog/model';
import { NewComment, NewCommentParams } from 'portcall/eventlog/newcomment';

import {
    CoordinationCardLogUpdater as LogUpdater,
    CoordinationCardLogUpdaterParams as LogUpdaterParams
} from './logupdater';

export interface CoordinationCardDetailsLogTabParams {
    CoordinationCardSelf : CoordinationCardSelf;
}

export type CoordinationCardDetailsLogTab = ReturnType<typeof CoordinationCardDetailsLogTab>;
export function CoordinationCardDetailsLogTab(
    newCommentModel : (params : NewCommentParams) => NewComment,
    eventLogModel : (params : EventLogParams) => EventLog,
    logUpdaterModel : (params : LogUpdaterParams) => LogUpdater,
    { CoordinationCardSelf } : CoordinationCardDetailsLogTabParams
) {
    const
        EventLog = eventLogModel({
            log: CoordinationCardSelf.Log,
            canComment: () => true
        }),
        NewComment = newCommentModel({
            url: CoordinationCardSelf.CommentsUrl
        }),
        LogUpdater = logUpdaterModel({ CoordinationCardSelf }),
        // Count number of times our LogUpdater's isRequesting signal flips from true to false, starting at 0 and
        // stopping at 1.
        logUpdatesCalc = S<[attemptsCompleted : number, isRequesting : boolean]>(
            ([prevCount, wasRequesting]) =>
                prevCount >= 1 ? [1, wasRequesting] :
                [prevCount + (wasRequesting && !LogUpdater.isRequesting() ? 1 : 0), LogUpdater.isRequesting()],
            [0, S.sample(LogUpdater.isRequesting)]
        ),
        // For the purposes of telling calling code whether to show a loading spinner or not, we wanna say that
        // we're loading if we're making our first attempt to load the log but not for any later attempts.
        Loading = () => logUpdatesCalc()[0] === 0 && LogUpdater.isRequesting();

    return {
        EventLog,
        NewComment,
        LogUpdater,
        Loading
    };
}



// WEBPACK FOOTER //
// ./apps/portcall/coordinationcarddetails/log.ts